export default function(paramName, queryString) {
    paramName = paramName.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + paramName + "=([^&#]*)"),
        results = regex.exec(queryString ? queryString : window.location.href);
    return results == null
        ? ""
        : decodeURIComponent(results[1].replace(/\+/g, " "));
}



// WEBPACK FOOTER //
// ./src/js/utilities/get-query-param.js